<template>
	<div class="ov-field">
		<label v-if="label" class="ov-field__label">{{ label }}</label>
		<select
			class="ov-select"
			:value="modelValue"
			:disabled="disabled"
			@change="$emit('update:modelValue', $event.target.value)"
		>
			<slot />
		</select>
	</div>
</template>

<script>
export default {
	name: "OvSelect",
	props: {
		modelValue: { type: [String, Number], default: "" },
		label: { type: String, default: "" },
		disabled: { type: Boolean, default: false },
	},
	emits: ["update:modelValue"],
};
</script>

<style lang="scss" scoped>
.ov-field__label {
	display: block;
	margin-bottom: var(--ds-space-1);
	font-size: var(--ds-font-size-xs);
	font-weight: var(--ds-font-weight-medium);
	color: var(--ds-color-text-muted);
}

.ov-select {
	display: block;
	width: 100%;
	height: var(--ds-control-height);
	padding: 0 var(--ds-space-3);
	font-family: inherit;
	font-size: var(--ds-font-size-sm);
	color: var(--ds-color-text);
	background: var(--ds-color-surface);
	border: var(--ds-border-width) solid var(--ds-color-border);
	border-radius: var(--ds-radius-sm);
	cursor: pointer;
	transition: border-color 0.15s, box-shadow 0.15s;
	appearance: auto;

	&:hover:not(:disabled) {
		border-color: #cbd5e1;
	}

	&:focus {
		outline: none;
		border-color: var(--ds-color-primary);
		box-shadow: 0 0 0 3px var(--ds-color-primary-subtle);
	}

	&:disabled {
		background: var(--ds-color-bg);
		color: var(--ds-color-text-muted);
		cursor: not-allowed;
	}
}
</style>
